import { useMemo } from 'react';

export const useConfigIds = (
  records: readonly Record<string, unknown>[] | undefined
): string[] =>
  useMemo(() => {
    const ids = new Set<string>();
    records?.forEach((r) => {
      if (typeof r.ConfigId === 'string') {
        ids.add(r.ConfigId);
      }
    });

    return Array.from(ids);
  }, [records]);
